import styled, {css} from 'styled-components';

export const Wrapper = styled.div`
	height: 100%;
	width: 100%;
`;

export const flexColCSS = css`
  display:flex;
  flex-direction: column;
`;

export const flexRowCSS = css`
  display:flex;
  flex-direction: row;
`;

export const green = '#039000' ;

export const red = 'red';
